import { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Dropdown } from 'antd';
import { Settings, User, List, CreditCard, Gift, Trash2, Sun, Moon, LogOut } from 'lucide-react';
import AppContext from '@context/AppContext';
import { logout } from '@store/slices/authSlice';
import { clearLocal } from '@utils/storage';
import { toast } from '@components/ui/toast/Toast';
import './ProfileMenu.scss';

const ProfileMenu = () => {
    const { config: { isDark }, toggleDark } = useContext(AppContext);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [cacheCleared, setCacheCleared] = useState(false);

    const handleClearCache = () => {
        clearLocal();
        toast.success('Cache cleared successfully');
        setCacheCleared(true);
    };

    const handleLogout = () => {
        dispatch(logout());
        navigate('/authentication/login');
    };

    const items = [
        { key: 'profile', label: <Link to="/account/profile" className="pmenu-item"><User size={14} />Profile</Link> },
        { key: 'broker', label: <Link to="/account/broker-login" className="pmenu-item"><List size={14} />Broker List</Link> },
        { key: 'subscriptions', label: <Link to="/account/subscriptions" className="pmenu-item"><CreditCard size={14} />My Subscriptions</Link> },
        { key: 'pricing', label: <Link to="/pricing" className="pmenu-item"><CreditCard size={14} />Purchase Plans</Link> },
        { key: 'refer', label: <Link to="/account/refer" className="pmenu-item"><Gift size={14} />Refer</Link> },
        { type: 'divider' },
        {
            key: 'theme',
            label: (
                <button className="pmenu-item pmenu-item--btn" onClick={toggleDark}>
                    {isDark ? <Sun size={14} /> : <Moon size={14} />}
                    {isDark ? 'Light mode' : 'Dark mode'}
                </button>
            ),
        },
        {
            key: 'cache',
            disabled: cacheCleared,
            label: (
                <button className="pmenu-item pmenu-item--btn" onClick={handleClearCache} disabled={cacheCleared}>
                    <Trash2 size={14} /> Clear Cache
                </button>
            ),
        },
        { type: 'divider' },
        {
            key: 'logout',
            label: (
                <button className="pmenu-item pmenu-item--btn pmenu-item--danger" onClick={handleLogout}>
                    <LogOut size={14} /> Logout
                </button>
            ),
        },
    ];

    return (
        <Dropdown
            menu={{ items }}
            trigger={['click']}
            placement="bottomRight"
            rootClassName="profile-dropdown-overlay"
        >
            <button className="nav-icon-btn" aria-label="Settings">
                <Settings size={16} />
            </button>
        </Dropdown>
    );
};

export default ProfileMenu;